var installedModules = {};
var moduleToHandlerMapping = {
	78286: {
		getter: () => (() => (__webpack_require__(96540))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	56370: {
		getter: () => (() => (__webpack_require__(40961))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	1973: {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-router-dom_dist_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom")]).then(() => (() => (__webpack_require__(92648))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "6.28.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	99277: {
		getter: () => (__webpack_require__.e("vendors-node_modules_date-fns_index_js").then(() => (() => (__webpack_require__(44353))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.1.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "date-fns",
	},
	62214: {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_rxjs_dist_esm5_internal_Observable_js-node_modules_rxjs_dist_esm5_intern-f4926f"), __webpack_require__.e("vendors-node_modules_rxjs_dist_esm5_index_js")]).then(() => (() => (__webpack_require__(30395))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.8.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	98987: {
		getter: () => (__webpack_require__.e("node_modules_clsx_dist_clsx_mjs").then(() => (() => (__webpack_require__(34164))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.1.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "clsx",
	},
	2286: {
		getter: () => (() => (__webpack_require__(32389))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "15.4.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-i18next",
	},
	83402: {
		getter: () => (__webpack_require__.e("vendors-node_modules_easepick_bundle_dist_index_esm_js").then(() => (() => (__webpack_require__(72975))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "1.2.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@easepick/bundle",
	},
	80076: {
		getter: () => (__webpack_require__.e("vendors-node_modules_lodash_lodash_js").then(() => (() => (__webpack_require__(2543))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.17.21",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	32763: {
		getter: () => (__webpack_require__.e("vendors-node_modules_prismjs_prism_js").then(() => (() => (__webpack_require__(28848))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "1.30.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "prismjs",
	},
	65639: {
		getter: () => (__webpack_require__.e("vendors-node_modules_tanstack_react-table_build_lib_index_mjs").then(() => (() => (__webpack_require__(59233))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "8.21.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-table",
	},
	40385: {
		getter: () => (__webpack_require__.e("node_modules_easepick-plugin-amp_dist_module_js").then(() => (() => (__webpack_require__(93876))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "easepick-plugin-amp",
	},
	13049: {
		getter: () => (__webpack_require__.e("node_modules_easepick-plugin-keyboard_dist_module_js").then(() => (() => (__webpack_require__(14373))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "easepick-plugin-keyboard",
	},
	81341: {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-ease-picker_dist_module_js"), __webpack_require__.e("webpack_sharing_consume_default_easepick_core_easepick_core-webpack_sharing_consume_default_e-44bf1d")]).then(() => (() => (__webpack_require__(76036))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.19",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-ease-picker",
	},
	50666: {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_react_jsx-runtime_js-node_modules_classnames_index_js-node_modules_babel-c49ede"), __webpack_require__.e("vendors-node_modules_react-js-cron_dist_esm_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom")]).then(() => (() => (__webpack_require__(91536))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.0.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-js-cron",
	},
	43638: {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_prop-types_index_js"), __webpack_require__.e("vendors-node_modules_tabbable_dist_index_esm_js"), __webpack_require__.e("vendors-node_modules_focus-trap-react_dist_focus-trap-react_js")]).then(() => (() => (__webpack_require__(94708))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "10.3.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "focus-trap-react",
	},
	58777: {
		getter: () => (__webpack_require__.e("vendors-node_modules_highcharts_highcharts_js").then(() => (() => (__webpack_require__(14783))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "11.0.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "highcharts",
	},
	97749: {
		getter: () => (__webpack_require__.e("node_modules_highcharts-react-official_dist_highcharts-react_min_js").then(() => (() => (__webpack_require__(85316))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "3.2.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "highcharts-react-official",
	},
	31700: {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_lodash__baseMerge_js-node_modules_lodash__createAssigner_js"), __webpack_require__.e("vendors-node_modules_lodash_isEmpty_js-node_modules_lodash_isEqual_js-node_modules_lodash_mer-babe09"), __webpack_require__.e("vendors-node_modules_atob_browser-atob_js-node_modules_btoa_index_js-node_modules_lodash_debo-9842d6"), __webpack_require__.e("webpack_sharing_consume_default_date-fns_date-fns-webpack_sharing_consume_default_react-route-59e3d5"), __webpack_require__.e("webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("packages_dxp-console-support_dist_mjs_index_js")]).then(() => (() => (__webpack_require__(8380))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "1.12.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@squiz/dxp-console-support",
	},
	62204: {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_prop-types_index_js"), __webpack_require__.e("vendors-node_modules_react-beautiful-dnd_dist_react-beautiful-dnd_esm_js"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom")]).then(() => (() => (__webpack_require__(25177))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.1.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-beautiful-dnd",
	},
	48295: {
		getter: () => (__webpack_require__.e("node_modules_zustand_esm_index_mjs").then(() => (() => (__webpack_require__(81621))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.5.5",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "zustand",
	},
	82013: {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_prop-types_index_js"), __webpack_require__.e("vendors-node_modules_dom-helpers_esm_addClass_js-node_modules_dom-helpers_esm_removeClass_js--90c698"), __webpack_require__.e("vendors-node_modules_react-transition-group_esm_index_js-node_modules_babel_runtime_helpers_e-dbbd1b"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom")]).then(() => (() => (__webpack_require__(45940))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.4.5",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-transition-group",
	},
	68373: {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_highcharts_modules_accessibility_js-node_modules_highcharts_modules_sank-76bddd"), __webpack_require__.e("webpack_sharing_consume_default_date-fns_date-fns-webpack_sharing_consume_default_react-route-59e3d5"), __webpack_require__.e("libs_sds_src_Components_index_ts"), __webpack_require__.e("libs_sds_src_index_ts")]).then(() => (() => (__webpack_require__(3890))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "1.13.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@squiz/sds",
	},
	57540: {
		getter: () => (__webpack_require__.e("vendors-node_modules_react-element-to-jsx-string_dist_cjs_index_js").then(() => (() => (__webpack_require__(34223))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "15.0.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-element-to-jsx-string",
	},
	85433: {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_prop-types_index_js"), __webpack_require__.e("vendors-node_modules_lodash_isEmpty_js-node_modules_lodash_isEqual_js-node_modules_lodash_mer-babe09"), __webpack_require__.e("vendors-node_modules_react_jsx-runtime_js-node_modules_classnames_index_js-node_modules_babel-c49ede"), __webpack_require__.e("vendors-node_modules_tabbable_dist_index_esm_js"), __webpack_require__.e("vendors-node_modules_dom-helpers_esm_addClass_js-node_modules_dom-helpers_esm_removeClass_js--90c698"), __webpack_require__.e("vendors-node_modules_squiz_component-editing-ui_lib_index_js"), __webpack_require__.e("webpack_sharing_consume_default_squiz_dxp-ai-client_squiz_dxp-ai-client-webpack_sharing_consu-bba040"), __webpack_require__.e("_4f7e")]).then(() => (() => (__webpack_require__(44569))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.22.6",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@squiz/component-editing-ui",
	},
	35557: {
		getter: () => (() => (__webpack_require__(72635))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "24.2.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "i18next",
	},
	80429: {
		getter: () => (__webpack_require__.e("node_modules_squiz_component-editing-ui_node_modules_clsx_dist_clsx_m_js").then(() => (() => (__webpack_require__(67369))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.1.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "clsx",
	},
	79169: {
		getter: () => (__webpack_require__.e("vendors-node_modules_immer_dist_immer_mjs").then(() => (() => (__webpack_require__(1932))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "10.1.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "immer",
	},
	73242: {
		getter: () => (__webpack_require__.e("vendors-node_modules_squiz_dxp-ai-client_dist_index_js").then(() => (() => (__webpack_require__(33482))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "1.8.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@squiz/dxp-ai-client",
	},
	45398: {
		getter: () => (__webpack_require__.e("vendors-node_modules_semver_index_js").then(() => (() => (__webpack_require__(99589))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.7.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "semver",
	},
	90070: {
		getter: () => (__webpack_require__.e("node_modules_easepick_core_dist_index_esm_js-_f93d1").then(() => (() => (__webpack_require__(75014))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "1.2.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@easepick/core",
	},
	58342: {
		getter: () => (__webpack_require__.e("node_modules_react-ease-picker_node_modules_easepick-plugin-amp_dist_module_js-_909c1").then(() => (() => (__webpack_require__(66925))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "easepick-plugin-amp",
	},
	48506: {
		getter: () => (__webpack_require__.e("node_modules_react-ease-picker_node_modules_easepick-plugin-keyboard_dist_module_js-_d0cd1").then(() => (() => (__webpack_require__(40294))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "easepick-plugin-keyboard",
	}
};
var initialConsumes = [78286];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"main": [
		78286
	],
	"webpack_sharing_consume_default_react-dom_react-dom": [
		56370
	],
	"webpack_sharing_consume_default_date-fns_date-fns-webpack_sharing_consume_default_react-route-59e3d5": [
		1973,
		99277
	],
	"webpack_sharing_consume_default_rxjs_rxjs": [
		62214
	],
	"webpack_sharing_consume_default_clsx_clsx": [
		98987
	],
	"libs_sds_src_Components_index_ts": [
		2286,
		83402,
		80076,
		32763,
		65639,
		40385,
		13049,
		81341,
		50666,
		43638,
		58777,
		97749
	],
	"webpack_sharing_consume_default_squiz_dxp-console-support_squiz_dxp-console-support-webpack_s-8760ac": [
		31700,
		62204,
		48295,
		82013
	],
	"webpack_sharing_consume_default_squiz_sds_squiz_sds": [
		68373
	],
	"apps_console-host_src_main_tsx": [
		57540,
		85433,
		35557
	],
	"webpack_sharing_consume_default_squiz_dxp-ai-client_squiz_dxp-ai-client-webpack_sharing_consu-bba040": [
		80429,
		79169,
		73242
	],
	"packages_dxp-console-support_dist_mjs_index_js": [
		45398
	],
	"webpack_sharing_consume_default_easepick_core_easepick_core-webpack_sharing_consume_default_e-44bf1d": [
		90070,
		58342,
		48506
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}